import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Card, List, Row, Col, Typography } from 'antd';
import moment from 'moment';
import formatAmount from 'indian-currency-formatter';
import * as Config from '../../../appConfig';

const { Text } = Typography;

const { TabPane } = Tabs;

const ListItem = ({ item, strong = false, alignRight = false }) => {
  return (
    <List.Item>
      <Text
        strong={strong}
        style={alignRight ? { textAlign: 'right', width: '100%' } : ''}
      >
        {item}
      </Text>
    </List.Item>
  );
};

const PayslipDetails = ({ payslip, ability }) => {
  const { employee } = payslip;

  // const getAggregatedSumValue = (list) => {
  //   if (list) {
  //     return list.reduce(function (sum, item) {
  //       return sum + parseFloat(item.amount);
  //     }, 0);
  //   }
  //   return 0;
  // };

  const earnings = (() => {
    const list = [];
    if (payslip.conveyanceAdjusted) {
      list.push({
        label: 'Conveyance',
        value: formatAmount(payslip.conveyanceAdjusted),
      });
    }
    if (payslip.incentives && payslip.incentives.length > 0) {
      list.push({
        label: 'Incentives',
        value: formatAmount(payslip.totalIncentive),
      });
    }
    if (payslip.allowances && payslip.allowances.length > 0) {
      list.push({
        label: 'Other Allowances',
        value: formatAmount(payslip.totalAllowance),
      });
    }
    return list;
  })();

  return (
    <>
      <Card
        title={`Paylist #${payslip.id} - ${moment(payslip.for_month).format(
          Config.DATE_MONTH_FORMAT
        )}`}
        bordered={false}
        style={{ maxWidth: '1200px' }}
      >
        <Row>
          <Col xs={16} md={5}>
            <List
              dataSource={['Employee Name', 'EMP ID']}
              renderItem={(item) => <ListItem item={item} strong />}
            />
          </Col>
          <Col xs={8} md={6}>
            <List
              dataSource={[
                `${employee.first_name} ${employee.last_name}`,
                employee.emp_id,
              ]}
              renderItem={(item) => <ListItem item={item} />}
            />
          </Col>
          <Col xs={24} md={1}></Col>
          <Col xs={16} md={5}>
            <List
              dataSource={['D.O.J', 'Designation', 'Leave Adjusted']}
              renderItem={(item) => <ListItem item={item} strong />}
            />
          </Col>
          <Col xs={8} md={7}>
            <List
              dataSource={[
                moment(employee.date_of_joining).format(Config.DATE_FORMAT),
                employee.designation.name,
                payslip.leave_adjusted ? payslip.leave_adjusted : '-',
              ]}
              renderItem={(item) => <List.Item>{item}</List.Item>}
            />
          </Col>
        </Row>
      </Card>
      <div>&nbsp;</div>

      <Card bordered={true} style={{ maxWidth: '1200px' }}>
        <Row>
          <Col xs={16} md={7}>
            <List
              dataSource={[
                <Text strong>Earning</Text>,
                ...earnings.map((i) => i.label),
              ]}
              renderItem={(item) => <ListItem item={item} />}
            />
          </Col>
          <Col xs={8} md={4}>
            <List
              dataSource={[
                <Text strong>Amount</Text>,
                ...earnings.map((i) => i.value),
              ]}
              renderItem={(item) => <ListItem item={item} alignRight />}
            />
          </Col>
          <Col xs={24} md={1}></Col>
          <Col xs={16} md={8}>
            {payslip.deductions && payslip.deductions.map((deduction) => <></>)}
            <List
              dataSource={[
                <Text strong>Deduction</Text>,
                'Common Deduction',
              ].concat(
                payslip.deductions
                  ? payslip.deductions.map((i) => i.deductionType.name)
                  : []
              )}
              renderItem={(item) => <ListItem item={item} />}
            />
          </Col>
          <Col xs={8} md={4}>
            <List
              dataSource={[
                <Text strong>Amount</Text>,
                formatAmount(payslip.taxDeduction),
                ...payslip.deductions.map((i) => i.amount),
              ]}
              renderItem={(item) => <ListItem item={item} alignRight />}
            />
          </Col>
        </Row>
        <Row>
          <Col
            span={24}
            style={{
              height: '4rem',
              marginBottom: '1rem',
              borderBottom: '1px solid #f0f0f0',
            }}
          >
            &nbsp;
          </Col>
        </Row>
        <Row>
          <Col span={7}>
            <Text strong>Total Earnings</Text>
          </Col>
          <Col span={4} style={{ textAlign: 'right' }}>
            {formatAmount(payslip.totalEarning)}
          </Col>
          <Col span={1}></Col>
          <Col span={8}>
            <Text strong>Total Deductions</Text>
          </Col>
          <Col span={4} style={{ textAlign: 'right' }}>
            {formatAmount(payslip.totalDeduction)}
          </Col>
        </Row>
        <Row>
          <Col
            span={24}
            style={{ marginBottom: '1rem', borderBottom: '1px solid #f0f0f0' }}
          >
            &nbsp;
          </Col>
        </Row>
        <Row>
          <Col span={7}>
            <Text strong>Previous Balance</Text>
          </Col>
          <Col span={4} style={{ textAlign: 'right' }}>
            {formatAmount(payslip.balance_adjusted)}
          </Col>
          <Col span={13}></Col>
        </Row>
        <Row>
          <Col
            span={24}
            style={{ marginBottom: '1rem', borderBottom: '1px solid #f0f0f0' }}
          >
            &nbsp;
          </Col>
        </Row>
        <Row>
          <Col span={7}>
            <Text strong>Net Earnings</Text>
          </Col>
          <Col span={4} style={{ textAlign: 'right' }}>
            {formatAmount(payslip.netEarning)}
          </Col>
          <Col span={13}></Col>
        </Row>
      </Card>
    </>
  );
};

PayslipDetails.defaultProps = {};

PayslipDetails.propTypes = {
  payslip: PropTypes.object.isRequired,
  ability: PropTypes.object.isRequired,
};

export default PayslipDetails;
